import { Star, ExternalLink } from "lucide-react";
import { REVIEWS } from "../content/defaults";

function Stars() {
  return (
    <span className="stars" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={16} fill="currentColor" strokeWidth={0} />)}
    </span>
  );
}

export function ReviewCards() {
  const google = REVIEWS.providers[0], yelp = REVIEWS.providers[1], nextdoor = REVIEWS.providers[2];
  return (
    <div data-testid="ratings-banner-opening">
      <div className="review-cards">
        <a className="review-card" href={google.profile} target="_blank" rel="noopener noreferrer" data-testid="intro-rating-google">
          <span className="platform">Google</span>
          <div className="score">4.9 <Stars /></div>
          <span className="src">111 Google reviews<br />{google.note}</span>
          <span className="act">Read reviews <ExternalLink size={12} style={{ verticalAlign: -2 }} /></span>
        </a>
        <a className="review-card" href={yelp.profile} target="_blank" rel="noopener noreferrer" data-testid="intro-rating-yelp">
          <span className="platform">Yelp</span>
          <div className="score">4.7 <Stars /></div>
          <span className="src">50 Yelp reviews<br />{yelp.note}</span>
          <span className="act">Leave a review <ExternalLink size={12} style={{ verticalAlign: -2 }} /></span>
        </a>
      </div>
      <a className="review-nextdoor" href={nextdoor.profile} target="_blank" rel="noopener noreferrer" data-testid="intro-rating-nextdoor">
        Also recommended on Nextdoor →
      </a>
    </div>
  );
}
